import { IconX } from "@tabler/icons-react";
import ButtonStyled from "../../../components/common/ButtonStyled"; 
import { FieldErrors, UseFormRegister } from "react-hook-form";
import TextareaField from "../../../components/common/TextareaField";

type DeleteModalProps = {
  open: boolean;
  onClose: () => void;
  deleteOrder: () => void;
  isDeletePending: boolean;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  clearErrors?: any;
  setValue?: any;
  watch?: any;
};

export default function DeleteModal({
  open,
  onClose,
  deleteOrder,
  isDeletePending,
  register,
  errors,
  clearErrors,
  setValue,
  watch,
}: DeleteModalProps) { 

  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="  rounded-2xl ">
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h2 className="text-2xl">Are you sure want to Delete?</h2>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>
        <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className="w-[500px]  space-y-2 flex flex-col">
            {/* <SelectInput
              name="warehouseId"
              label="Select Warehouse"
              className="col-span-3"
              placeholder=""
              selectOptions={
                warehouses?.map((warehouse: any) => ({
                  id: warehouse?.id,
                  value: warehouse?.id,
                  text: warehouse?.name,
                })) || []
              }
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Warehouse is required" }}
              error={errors.warehouseId}
              disabled={!warehouses || warehouses?.length === 0}
              value={watch("warehouseId")}
              setValue={(val: string) => {
                setValue("warehouseId", val);
              }}
            /> */}

            <TextareaField
              rows={2}
              className="col-span-3"
              label="Comment"
              register={register}
              name="comment"
              placeholder=""
              error={errors.comment}
            />
            {/* <div className="w-[500px]  space-y-2 flex flex-col justify-center items-center">
              <img src="/img/delete-product.png" alt="" />
              <p className="text-[#212121]">Are you sure want to Delete?</p>
            </div> */}
          </div>
        </div>

        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          <ButtonStyled
            value={"Confirm"}
            onClick={deleteOrder}
            extraClasses=""
            isPending={isDeletePending}
          />
        </div>
      </div>
    </div>
  );
}
